var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "casino-navigation" },
    [
      _vm._l(_vm.navigationItems, function(navGroup, gIndex) {
        return !(
          _vm.mobileBigAndBelow && navGroup.cssClass === "popular-desktop"
        ) &&
          _vm.navigationItems &&
          !_vm.isMobile
          ? _c(
              "li",
              { key: gIndex, class: ["navigation-group", navGroup.layout] },
              [
                _c(
                  "div",
                  {
                    staticClass: "nav-slider-body",
                    attrs: { id: "nav-body-" + gIndex }
                  },
                  [
                    _vm.isScroll && _vm.showPrev && !_vm.mobileBigAndBelow
                      ? _c(
                          "button",
                          {
                            staticClass: "prev-btn casino-slider-btn",
                            attrs: { id: "prev-btn-" + gIndex },
                            on: {
                              click: function($event) {
                                return _vm.slide(gIndex, "prev")
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("arrow_back_ios")])],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        staticClass: "navigation",
                        attrs: {
                          id: "nav-list-" + gIndex,
                          "data-nav-list-id": gIndex
                        }
                      },
                      _vm._l(navGroup.nodes, function(item, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            staticClass: "navigation-item",
                            on: {
                              click: function($event) {
                                return _vm.setChildren(item)
                              }
                            }
                          },
                          [
                            ["INTERNAL", "GROUP"].includes(item.linkType)
                              ? _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        path:
                                          "/" + _vm.$i18n.locale + item.uri ||
                                          "/"
                                      },
                                      id: item.id
                                    }
                                  },
                                  [
                                    item.cssClass && item.cssClass !== "default"
                                      ? _c("icon", {
                                          attrs: { name: item.cssClass }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(item.text))])
                                  ],
                                  1
                                )
                              : item.linkType === "URL"
                              ? _c(
                                  "a",
                                  {
                                    class: item.cssClass,
                                    attrs: {
                                      href: item.uri,
                                      setTarget: _vm.setExternalNavigationTarget(
                                        "casino-nav-item-" + item.id,
                                        item.target
                                      ),
                                      id: "casino-nav-item-" + item.id,
                                      rel: "external",
                                      "aria-label": item.text
                                    }
                                  },
                                  [
                                    item.cssClass && item.cssClass !== "default"
                                      ? _c("icon", {
                                          attrs: { name: item.cssClass }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "item-text" }, [
                                      _vm._v(_vm._s(item.text))
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.isScroll && _vm.showNext && !_vm.mobileBigAndBelow
                      ? _c(
                          "button",
                          {
                            staticClass: "next-btn casino-slider-btn",
                            attrs: { id: "next-btn-" + gIndex },
                            on: {
                              click: function($event) {
                                return _vm.slide(gIndex, "next")
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("arrow_forward_ios")])],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _vm._l(_vm.navigationItems[0].nodes, function(item, index) {
        return _vm.isMobile
          ? _c(
              "div",
              {
                key: index,
                class: ["sport", "section"],
                on: {
                  click: function($event) {
                    return _vm.setChildren(item)
                  }
                }
              },
              [
                ["INTERNAL", "GROUP"].includes(item.linkType)
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          to: { path: "/" + _vm.$i18n.locale + item.uri || "/" }
                        }
                      },
                      [
                        item.cssClass && item.cssClass !== "default"
                          ? _c("icon", {
                              attrs: {
                                name: item.cssClass,
                                "color-name": "white"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "mobile-menu-text" }, [
                          _vm._v(_vm._s(item.text))
                        ])
                      ],
                      1
                    )
                  : item.linkType === "URL"
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            path: "/" + _vm.$i18n.locale + item.uri || "/"
                          },
                          setTarget: _vm.setExternalNavigationTarget(
                            "casino-nav-item-" + item.id,
                            item.target
                          ),
                          id: "casino-nav-item-" + item.id,
                          rel: "external"
                        }
                      },
                      [
                        item.cssClass && item.cssClass !== "default"
                          ? _c("icon", {
                              attrs: {
                                name: item.cssClass,
                                "color-name": "white"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "mobile-menu-text" }, [
                          _vm._v(_vm._s(item.text))
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.activeChildren.length > 0
        ? _c("casino-sub-navigation", {
            attrs: { children: _vm.activeChildren }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60efbc6f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60efbc6f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoNavigation.vue
// module id = null
// module chunks = 